export function enqueue(blcktive, event) {
  if (blcktive.event) {
    blcktive._eventQueue.push(blcktive.event);
  }

  blcktive.event = event;
}

export function dequeue(blcktive) {
  if (blcktive._eventQueue.length) {
    blcktive.event = blcktive._eventQueue.pop();
  } else {
    blcktive.event = null;
  }
}
